import React from 'react';
import { bool, func, string, oneOf } from 'prop-types';
import cn from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { l_thumbs_down, l_thumbs_up } from '@fiverr-private/icons';

import './styles.scss';

const ICON_SIZE = 14;

const ICON_NAME = {
    UP: 'up',
    DOWN: 'down',
};

const iconsMap = {
    [ICON_NAME.UP]: l_thumbs_up,
    [ICON_NAME.DOWN]: l_thumbs_down,
};

const HelpfulThumb = ({ title = '', iconName, selected = false, selectedClassName = null, onSelect = () => null }) => {
    const icon = iconsMap[iconName];

    return (
        <div
            className={cn('helpful-thumb', 'text-body-2', { selected }, { [selectedClassName]: selected })}
            onClick={onSelect}
        >
            <Icon className="thumbs-icon" size={ICON_SIZE}>
                {icon}
            </Icon>
            <span className="thumb-title">{title}</span>
        </div>
    );
};

HelpfulThumb.ICON_NAME = ICON_NAME;

HelpfulThumb.propTypes = {
    iconName: oneOf([ICON_NAME.UP, ICON_NAME.DOWN]),
    selectedClassName: string,
    onSelect: func,
    selected: bool,
};

export default HelpfulThumb;
